import { render, staticRenderFns } from "./AS2CsRes.vue?vue&type=template&id=82c32a4c&scoped=true&"
import script from "./AS2CsRes.vue?vue&type=script&lang=js&"
export * from "./AS2CsRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c32a4c",
  null
  
)

export default component.exports